<section class="header-btn-wrapper">
    <button type="button" nz-button nzType="primary" (click)="showItem()">
        <i class="fas fa-fw fa-plus"></i> Add Asset Library Tab
    </button>
</section>

<ag-grid-angular #agGrid domLayout='autoHeight' class="ag-theme-alpine" [rowData]="data" [columnDefs]="columnDefs"
    rowSelection="multiple" [defaultColDef]="defaultColDef" [pagination]="true" [suppressRowClickSelection]="true"
    (gridReady)="onGridReady($event)" [enableCellTextSelection]="true">
</ag-grid-angular>
<section class="footer-btn-wrapper">
    <button type="button" nz-button nzType="default" (click)="preview()" style="margin-right: 5px;">
        <i class="fas fa-fw fa-eye"></i> Preview Library
    </button>

    <button type="button" nz-button nzType="primary" (click)="updateLibrary()">
        <i class="fas fa-fw fa-floppy-disk"></i> Update Library
    </button>
</section>